$(document).ready(function () {
   $('form.new_album .actions input, form.edit_album .actions input').on('click', function () {
      $('#albumUploadSpinner').show();
   });
});